import moment from "moment";
import React from "react";
import { PhoneCall, Mail, ChevronLeft, ChevronRight } from "react-feather";
import { FaWhatsapp } from "react-icons/fa";
import { Button, Col, Container, Row } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <section className="footer-Content">
          <div>
            <Container>
              <Row>
                <Col md="6" lg="3" sm="12" xs="12">
                  <h3 className="block-title">About Us</h3>
                  <div className="textwidget my-3">
                    <p>
                      Empowering the Auditing Community ! <br />
                      Find your dream audit role, connect with other auditors,
                      and stay updated on industry trends.
                    </p>
                  </div>
                </Col>

                <Col md="6" lg="3" sm="6" xs="12" className="pl-auto  pl-md-5">
                  <h3 className="block-title">Quick Links</h3>
                  <ul className="menu">
                    <li className="">
                      <a href="/">
                        {" "}
                        <ChevronRight size={16} /> Home
                      </a>
                    </li>
                    <li className="">
                      <a href="/jobs-opening-list">
                        <ChevronRight size={16} /> Job Openings
                      </a>
                    </li>
                    <li className="">
                      <a href="/contactus">
                        {" "}
                        <ChevronRight size={16} /> Contact
                      </a>
                    </li>
                    <li className="">
                      <a href="/terms-condition">
                        <ChevronRight size={16} /> Terms & Conditions
                      </a>
                    </li>
                    <li className="">
                      <a href="/privacy-policy">
                        <ChevronRight size={16} /> Privacy Policy
                      </a>
                    </li>
                  </ul>
                </Col>
                <Col md="6" lg="3" sm="6" xs="12">
                  <h3 className="block-title">Contact Us</h3>
                  <ul className="mt-3 textwidget footer-contact">
                    <li>
                      <a href="tel:+911244594949">
                        <PhoneCall size={15} />
                      </a>
                      <a>
                        <p>(+91)&nbsp;124&nbsp;4594949</p>
                      </a>
                    </li>
                    <li>
                      <a href="tel:+919319179297">
                        <PhoneCall size={15} />
                      </a>
                      <a>
                        <p>(+91)&nbsp;9319179297</p>
                      </a>
                    </li>

                    <li>
                      <a href="mailto:support@beteljobs.com">
                        <Mail size={15} />
                      </a>
                      <a>
                        <p>support@beteljobs.com</p>
                      </a>
                    </li>
                  </ul>
                  <ul className="mt-3 ml-2 footer-social">
                    <li>
                      <a
                        target="_blank"
                        className="facebook"
                        href="https://www.facebook.com/people/Betel-Jobs-By-TRPW-Partners/61573409279196/"
                      >
                        <i className="lni-facebook-filled"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="google-plus pb-3"
                        href="https://www.instagram.com/beteljobs/?utm_source=qr&igsh=djRkaGNhMDl4cWJo#"
                        target="_blank"
                        style={{ backgroundColor: "white" }}
                      >
                        {/* <i class="lni-instagram-filled"></i>
                         */}
                        <img
                          className="mb-1"
                          src="/assets/img/insta.png"
                          width={"15px"}
                          height={"15px"}
                          alt=""
                        />
                      </a>
                    </li>

                    <li>
                      <a
                        className="linkedin"
                        href="https://www.linkedin.com/company/beteljobs/about/?viewAsMember=true"
                        target="_blank"
                      >
                        <i className="lni-linkedin-fill"></i>
                      </a>
                    </li>

                    <li>
                      <a className="whataap bg-success" onClick={() => window.open('https://wa.me/9319179297', '_blank')}>
                        <FaWhatsapp className="text-light mb-1" size={19} />
                      </a>
                    </li>
                    {/* <li>
                      <a className="google-plus" href="#">
                        <i className="lni-google-plus"></i>
                      </a>
                    </li> */}
                  </ul>
                </Col>
                <Col md="6" lg="3" sm="12" xs="12">
                  {/* style={{ fontFamily: "serif" }} */}
                  <h3 className="block-title">
                    TRPW Strategic Partners Pvt. Ltd
                  </h3>
                  <div className="mt-3">
                    <p>
                      <b className="">India Office : </b>C-807, Unitech Business
                      Zone, Golf Course Extn Road, Sector-50, Gurgaon -122018,
                      Haryana, India
                    </p>
                    <p>
                      <b>Innovation Centre : </b>1059, LGF, Sector 47, Sohna
                      Road, Gurgaon-122001, Haryana, India
                    </p>
                    <p>
                      <b>USA Office : </b>24617, Greysteel SQ, Aldie, VA 20105
                    </p>
                    <br />
                  </div>
                  <Button
                    className="btns mt-2"
                    style={{ textTransform: "capitalize" }}
                    onClick={() =>
                      window.open("https://www.trpwpartners.com/", "_blank")
                    }
                  >
                    Website Link
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
        <div id="copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="site-info text-center">
                  <p>
                    <span
                      // href="https://www.trpwpartners.com/"
                      // target="__blank"
                      style={{ color: "#24324a" }}
                    >
                      TRPW Strategic Partners Pvt. Ltd{" "}
                    </span>
                    @ {moment().year()}. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
    return (
      <footer style={{ marginTop: "auto" }}>
        <section className="footer-Content">
          <div className="container">
            <div className="row gap-5">
              <div className="col-lg-3 col-md-6 col-xs-12 ">
                <div className="widget">
                  <h3 className="block-title">About Us</h3>
                  {/* <div className="footer-logo">
                    <img src="/assets/img/betel-jobs-logo-white.png" alt="" />
                  </div> */}
                  {/* <h3 className="block-title">Betel Jobs</h3> */}

                  <div className="textwidget mt-3">
                    <p>
                      Empowering the Auditing Community ! <br />
                      Find your dream audit role, connect with other auditors,
                      and stay updated on industry trends.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-xs-12">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div className="widget">
                    <h3 className="block-title">Quick Links</h3>
                    <ul className="menu">
                      <li className="">
                        <a href="/">
                          {" "}
                          <ChevronRight size={16} /> Home
                        </a>
                      </li>
                      <li className="">
                        <a href="/jobs-opening-list">
                          <ChevronRight size={16} /> Job Openings
                        </a>
                      </li>
                      <li className="">
                        <a href="/contactus">
                          {" "}
                          <ChevronRight size={16} /> Contact
                        </a>
                      </li>
                      <li className="">
                        <a href="/terms-condition" style={{ fontSize: "12px" }}>
                          <ChevronRight size={16} /> Terms & Conditions
                        </a>
                      </li>
                      <li className="">
                        <a href="/privacy-policy">
                          <ChevronRight size={16} /> Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="widget mt-3">
                  <h3 className="block-title">Contact Us</h3>
                  <ul className="mt-3 footer-contact">
                    <li >
                      <a href="tel:+919319179297">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;9319179297</a>
                    </li>
                    <li>
                      <a href="tel:+911244594949">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;1244594949</a>
                    </li>
                    <li>
                      <a href="mailto:support@beteljobs.com">
                        <Mail size={15} />
                      </a>
                      <a>support@beteljobs.com</a>
                    </li>
                  </ul>
                </div> */}
                  {/* <div>
                    <ul className="footer-social">
                      <li>
                        <a className="facebook" href="#">
                          <i className="lni-facebook-filled"></i>
                        </a>
                      </li>
                      <li>
                        <a className="google-plus" href="#">
                          <i class="lni-instagram-filled"></i>
                        </a>
                      </li>

                      <li>
                        <a className="twitter" href="#">
                          <i className="lni-twitter-filled"></i>
                        </a>
                      </li>
                      <li>
                        <a className="linkedin" href="#">
                          <i className="lni-linkedin-fill"></i>
                        </a>
                      </li>
                     
                    </ul>
                  </div> */}
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-xs-12">
                <div className="widget">
                  <h3 className="block-title">Contact Us</h3>
                  <ul className="mt-3 footer-contact">
                    <li>
                      <a href="tel:+919319179297">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;9319179297</a>
                    </li>
                    <li>
                      <a href="tel:+911244594949">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;1244594949</a>
                    </li>
                    <li>
                      <a href="mailto:support@beteljobs.com">
                        <Mail size={15} />
                      </a>
                      <a>support@beteljobs.com</a>
                    </li>
                  </ul>
                  <ul className="mt-3 footer-social">
                    <li>
                      <a className="facebook" href="#">
                        <i className="lni-facebook-filled"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        className="google-plus pb-3"
                        href="#"
                        style={{ backgroundColor: "white" }}
                      >
                        {/* <i class="lni-instagram-filled"></i>
                         */}
                        <img
                          src="/assets/img/insta.png"
                          width={"15px"}
                          height={"15px"}
                          alt=""
                        />
                      </a>
                    </li>

                    {/* <li>
                      <a className="twitter" href="#">
                        <i className="lni-twitter-filled"></i>
                      </a>
                    </li> */}
                    <li>
                      <a className="linkedin" href="#">
                        <i className="lni-linkedin-fill"></i>
                      </a>
                    </li>
                    <li>
                      <a className="google-plus" href="#">
                        <i className="lni-google-plus"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-xs-12">
                <div className="widget">
                  <h3 className="block-title" style={{ fontFamily: "serif" }}>
                    TRPW Strategic Partners Pvt. Ltd
                  </h3>

                  <div className="textwidget mt-3">
                    <p>
                      <strong>India Office :</strong> C-807, Unitech Business
                      Zone, Golf Course Extn Road, Sector-50, Gurgaon -122018,
                      Haryana, India <br />
                      <strong>Innovation Centre : </strong>1059, LGF, Sector 47,
                      Sohna Road, Gurgaon-122001, Haryana <br />
                      <strong>India USA Office :</strong> 24617, Greysteel SQ,
                      Aldie, VA 20105
                    </p>
                  </div>
                  <Button
                    className="btns mt-2"
                    style={{ textTransform: "capitalize" }}
                    onClick={() =>
                      window.open("https://www.trpwpartners.com/", "_blank")
                    }
                  >
                    Website Link
                  </Button>
                </div>
                {/* <div className="widget mt-3">
                  <h3 className="block-title">Contact Us</h3>
                  <ul className="mt-3 footer-contact">
                    <li >
                      <a href="tel:+919319179297">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;9319179297</a>
                    </li>
                    <li>
                      <a href="tel:+911244594949">
                        <PhoneCall size={15} />
                      </a>
                      <a>(+91)&nbsp;1244594949</a>
                    </li>
                    <li>
                      <a href="mailto:support@beteljobs.com">
                        <Mail size={15} />
                      </a>
                      <a>support@beteljobs.com</a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <div id="copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="site-info text-center">
                  <p>
                    <a
                      href="https://www.trpwpartners.com/"
                      target="__blank"
                      style={{ color: "#24324a" }}
                      rel="nofollow"
                    >
                      TRPW Strategic Partners Pvt. Ltd{" "}
                    </a>
                    @ {moment().year()}. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
